import dynamic from 'next/dynamic';
const Chart = dynamic(() => import('react-apexcharts'), { ssr: false });
import { Alert } from 'react-bootstrap';

export default function KayipKazancGrafik({ kayipKazanc }) {

  if (!kayipKazanc || kayipKazanc.length === 0) {
    return(
      <div className='p-4 pt-2'>
        <Alert variant='warning'>
          Kayıp/kazanç verileri mevcut değil.
        </Alert>
      </div>
    );
  }

  const kayipKazancOptions = {
    chart: {
      type: 'bar',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    plotOptions: {
      bar: {
        colors: {
          ranges: [{
            from: -100,
            to: 0,
            color: '#E11D48'  // Negatif değerler için renk
          }, {
            from: 0.01,
            to: 10000,
            color: '#11B981'  // Pozitif değerler için renk
          }]
        },
        columnWidth: '80%',
        endingShape: 'rounded',
      }
    },
    dataLabels: {
      enabled: false
    },
    xaxis: {
      categories: kayipKazanc.map(item => item.tarih),
      position: 'bottom',
      labels: {
        show: false
      },
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false
      },
      tooltip: {
        enabled: true,
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    grid: {
      show: false  // Arka plandaki grid çizgilerini kaldırır
    },
  };

  const kayipKazancSeries = [{
    name: 'Yüzde',
    data: kayipKazanc.map(item => parseFloat(item.yuzde))
  }];

  return(
    <div className='p-sm-0 p-lg-4 pt-0'>
      <Chart
        options={kayipKazancOptions}
        series={kayipKazancSeries}
        type="bar"
        width="100%"
        height='300'
      />
    </div>
  );
}